import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE } from "../i18n/i18n";

export const IsLaguagePresentInUrl = () : boolean => {
    const segment = window.location.pathname.split("/")[1] ?? '';
    return AVAILABLE_LANGUAGES.includes(segment) || /^[a-zA-Z]{2}(-[a-zA-Z]{2,})?$/.test(segment);
}

export const GetLanguageInUrl = () : string => {
    return IsLaguagePresentInUrl() ? `/${window.location.pathname.split("/")[1]}` : '';
}
export const GetDefaultLanguage = () : string => DEFAULT_LANGUAGE;

export const GetFormattedUrl = (path: string) : string => {
    const lang = IsLaguagePresentInUrl() ? GetLanguageInUrl() : `/${DEFAULT_LANGUAGE}`;
    return `${lang}/${path}`;
}

export const IsSectionInPath = (section: string) : boolean => window.location.pathname.split("/").some(s => s === section);
export const IsHome = () : boolean => window.location.pathname === `${GetLanguageInUrl()}`;
export const GoHome = () : void => {
    const url : string = IsLaguagePresentInUrl() ? GetLanguageInUrl() : `/${DEFAULT_LANGUAGE}`;
    window.location.href = url;
}

export const ImagePath = () : string => `images`;
